import { Badge } from "../ui";

import type { CarePlanContext } from "@/types/event";

interface CarePlanBadgeProps {
  carePlan: CarePlanContext;
  size?: "xs" | "sm";
}

export function CarePlanBadge({ carePlan, size = "sm" }: CarePlanBadgeProps) {
  return (
    <Badge size={size} className="inline-flex items-center">
      {carePlan.carePlanName} · Step {carePlan.stepNumber}
    </Badge>
  );
}
